/**
 * @function init Used to display & control overlay video on home page
 * @param {Object} params
 * @param {String} params.containerSelector
 * @param {String} params.closeButtonSelector
 **/
module.exports = function init(params) {
    var _ = require('lodash'),
        defaultOptions = {
            closeButtonSelector: '.js-home-video-container-close',
            containerSelector: '.js-home-video-container'
        };

    _.extend(defaultOptions, params);
    
    $(document).ready(function () {
        var $container = $(defaultOptions.containerSelector),
            util = require('./util'),
            $video = $container.find('video'),
            video = $video[0],
            $closeButton = $container.find(defaultOptions.closeButtonSelector);

        if ($container && $container.length && $video && $video.length) {

            function closeVideo() {
                $closeButton.detach();
                $('body').removeClass('m-fixed');
                $container.removeClass('homepage-hero-video');
                $('.slick-slider').slick('refresh');
                if(util.isMobile()){
                    setTimeout(function(){
                        $container.detach();
                    }, 350);
                } else {
                    $container.detach();
                }
            }

            $video.bind('click ended', closeVideo);
            $closeButton.bind('click', closeVideo);

            $video.bind('canplaythrough', function () {
                $container.removeClass('h-hidden');
                video.play();
            });
        }
    });
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/overlay-video.js